import React, { useEffect, useState } from "react";
import BackImg from "../assets/images/cart/back-icon.svg";
import Select, { components } from "react-select";
import ShowMoreProductsIcon from "../assets/images/show-more-products-icon.svg";
import Skeleton from "react-loading-skeleton";

import { Link } from "react-router-dom";
import { formatPrice } from "../helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSubscriptionDurations,
  fetchAllSubscriptions,
  deleteSubscription, 
  submitUpdateSubscription,
  clearMessages
} from "../features/subscription/subscriptionActions";
import { toast } from "react-toastify";

const CustomSvg = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 9.5L12 15.5L5 9.5"
      stroke="#00A991"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const customComponents = {
  DropdownIndicator: (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CustomSvg /> {/* Replace default DropdownIndicator with CustomSvg */}
      </components.DropdownIndicator>
    );
  },
};
const customStyles = {
  placeholder: (provided, state) => ({
    ...provided,
    color: "var(--color-secondary)",
    opacity: "0.62",
    fontSize: "clamp(14px, 0.833vw, 16px)",
    fontWeight: "500",
  }),
  valueContainer: (provided, state) => ({
    ...provided,

    padding: "0",
    borderRadius: "0",
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? "var(--color-gray)" : "var(--color-gray)",
    boxShadow: null,
    minWidth: "160px",
    padding: "7px 16px",
    borderRadius: "12px",
    "&:hover": {
      borderColor: state.isFocused ? "var(--color-gray)" : "var(--color-gray)",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    animation: "fadeIn 0.5s ease-in-out",
    margin: "5px 0 0",
    padding: 0,
    borderRadius: "12px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "var(--color-primary)"
      : state.isFocused
      ? "var(--color-primary-light)"
      : "var(--color-white)",
    color: state.isSelected
      ? "var(--color-white)"
      : state.isFocused
      ? "var(--color-secondary)"
      : "var(--color-secondary)",
    fontSize: "clamp(14px, 0.833vw, 16px)",
    fontWeight: "500",
    margin: 0,
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: "var(--color-white)",
    padding: "0",
    borderRadius: "12px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0",
  }),
};

function MySubscriptionComp() {
  const [selectedOption, setSelectedOption] = useState("Every 1 day");
  const [selectedSubscriptionItem, setSelectedSubscriptionItem] =
    useState(null);
  const [isActive, setIsActive] = useState(false);

  const [page, setPage] = useState(1);
  const [allSubscriptionItems, setSubscriptionItems] = useState([]);
  const [isVisibleShowMore, setIsVisibleShowMore] = useState(true);

  const dispatch = useDispatch();
  const { loading, subscriptions, errorMessage, successMessage } = useSelector((state) => state.subscription);
  const subscriptionDurations = useSelector(
    (state) => state.subscription.subscriptionDurations
  );

  const handleToggle = () => {
    setIsActive((prevState) => !prevState);
  };

  useEffect(() => {}, [subscriptionDurations]);

  useEffect(() => {
    let data = { page: 1, limit: 12 };
    dispatch(fetchAllSubscriptions(data));
    dispatch(fetchSubscriptionDurations());
  }, [dispatch]);

  // Re-fetch products when wishlistItems or page changes
  useEffect(() => {
    if (subscriptions?.data !== undefined) {
      if (page === 1) {
        setSubscriptionItems(subscriptions.data); // Set products for the first page
      } else {
        setSubscriptionItems((prev) => [...prev, ...subscriptions.data]); // Append new products
      }

      setIsVisibleShowMore(subscriptions.data.length >= 12); // Control "Show More" visibility
    } else {
      setIsVisibleShowMore(false);
    }
  }, [subscriptions, page]);

  // Load more products function
  const loadMoreSubscriptions = () => {
    const nextPage = page + 1;
    const data = { page: nextPage, limit: 12 };
    dispatch(fetchAllSubscriptions(data));
    setPage(nextPage); // Update the page number
  };

  const handleChangeSubscriptionDuration = (option) => {
    setSelectedOption(option);
  };

  const handleSelectionSubscription = (sub) => {
    setSelectedSubscriptionItem(sub);
    setSelectedOption({
      value: sub.subscription_duration_days,
      label: sub.subscription_duration_title,
    });
  };

  const handleRemoveSubscription = (id) => {
    dispatch(async (dispatch) => {
      await dispatch(deleteSubscription(id));
      dispatch(fetchAllSubscriptions({ page: 1, limit: 12 }));
    });
  };

  const handleUpdateSubscription = (sub) => {
    dispatch(async (dispatch) => {
      let formData = {
        subscription_duration_days: selectedOption.value,
        subscription_duration_title: selectedOption.label,
      }
      await dispatch(submitUpdateSubscription(sub.id, formData));
      dispatch(fetchAllSubscriptions({ page: 1, limit: 12 }));
      handleToggle();
    });

    
  }

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-error" });
      dispatch(clearMessages()); // Reset the messages after showing the toast
    }

    if (successMessage) {
      toast.success(successMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-success" });
      dispatch(clearMessages()); // Reset the messages after showing the toast
    }
  }, [successMessage, errorMessage, dispatch]);

  return (
    <>
      <div className={`${isActive ? "my-order-info isHide" : "my-order-info"}`}>
        <div className="tab-content-header">
          <h3>My Subscription</h3>
        </div>
        <div className="items-wrapper">
          <div>
            {loading ? ( // Check if loading is true
              <ul style={{ paddingLeft: 0 }}>
                {Array(12)
                  .fill()
                  .map(
                    (
                      _,
                      index // Adjust the number of skeletons as needed
                    ) => (
                      <div className="order-info-box" key={"sub-" + index}>
                        <div className="order-info-box-body">
                          <div className="order-info-box-item">
                            <div className="cart-box">
                              <div className="cart-box-img">
                                <Skeleton
                                  height={95}
                                  width={95}
                                  style={{ marginLeft: 5, borderRadius: 10 }}
                                />
                              </div>
                              <div className="cart-box-content">
                                <Skeleton height={15} width={80} />
                                <Skeleton height={17} width={150} />
                                <Skeleton height={24} width={100} />
                                <Skeleton height={20} width="20%" />
                              </div>

                              <div className="qty-wrapper">
                                <Skeleton height={15} width={95} />
                                <Skeleton height={15} width={95} />
                              </div>
                            </div>
                            <div className="bttn-group">
                              <Skeleton
                                height={35}
                                width={80}
                                style={{ marginRight: "10px" }}
                              />
                              <Skeleton height={35} width={80} />
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
              </ul>
            ) : allSubscriptionItems?.length > 0 ? (
              <ul style={{ paddingLeft: 0 }}>
                {allSubscriptionItems.map((wp, index) => (
                  <div className="order-info-box" key={"sub-" + index}>
                    <div className="order-info-box-body">
                      <div className="order-info-box-item">
                        <div className="cart-box">
                          <div className="cart-box-img">
                            <Link to={"/products/" + wp.product.slug}>
                              <img
                                src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${wp.product.image}`}
                                alt=""
                              />
                            </Link>
                          </div>
                          <div className="cart-box-content">
                            <span>{wp.product.category_title}</span>
                            <h2>
                              <Link to={"/products/" + wp.product.slug}>
                                {wp.product.title}
                              </Link>
                            </h2>
                            <p className="subscription-tag">
                              Subscription {wp.subscription_duration_title}
                            </p>
                            <Link
                              to={"/products/" + wp.product.slug}
                              className="price-value"
                            >
                              {wp.product.currency +
                                formatPrice(wp.selling_price)}
                            </Link>
                          </div>

                          <div className="qty-wrapper">
                            <p className="mb-0"> Qty : {wp.qty}</p>
                            <p className="mb-0">
                              {" "}
                              SubTotal :{" "}
                              {wp.product.currency +
                                formatPrice(wp.total_selling_price)}
                            </p>
                          </div>
                        </div>
                        <div className="bttn-group">
                          <Link
                            onClick={() => {
                              handleToggle();
                              handleSelectionSubscription(wp);
                            }}
                            className="cutsom-bttn"
                          >
                            {" "}
                            Update
                          </Link>
                          <Link
                            onClick={() => {
                              handleRemoveSubscription(wp.id);
                            }}
                            className="cutsom-bttn cancelled-bttn"
                          >
                            {" "}
                            Remove
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            ) : (
              <p className={loading ? "d-none" : ""}>No subscription found.</p>
            )}
          </div>
          <div className="d-flex justify-content-center">
            {!loading && (
              <Link
                to="#"
                onClick={loadMoreSubscriptions}
                className={`cutsom-bttn ${!isVisibleShowMore ? "d-none" : ""}`}
              >
                Show More <img src={ShowMoreProductsIcon} alt="" />
              </Link>
            )}
          </div>
        </div>
      </div>
      <div
        className={`${
          isActive ? "order-details-info" : "order-details-info isHide"
        }`}
      >
        <div className="tab-content-header">
          <h3>
            <Link to="" className="backToList" onClick={handleToggle}>
              <img src={BackImg} alt="" />
            </Link>{" "}
            My Subscription
          </h3>
        </div>
        {selectedSubscriptionItem && (
          <div className="order-info-box">
            <div className="order-info-box-body">
              <div className="order-info-box-item">
                <div className="cart-box">
                  <div className="cart-box-img">
                    <Link
                      to={"/products/" + selectedSubscriptionItem.product.slug}
                    >
                      <img
                        src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${selectedSubscriptionItem.product.image}`}
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="cart-box-content">
                    <span>
                      {selectedSubscriptionItem.product.category_title}
                    </span>
                    <h2>
                      <Link
                        to={
                          "/products/" + selectedSubscriptionItem.product.slug
                        }
                      >
                        {selectedSubscriptionItem.product.title}
                      </Link>
                    </h2>

                    <div className="delivery-select">
                      <label htmlFor="delivery-frequency" className="me-2">
                        Deliver :
                      </label>
                      <Select
                        value={selectedOption}
                        defaultValue={selectedOption}
                        onChange={handleChangeSubscriptionDuration}
                        options={subscriptionDurations}
                        styles={customStyles}
                        placeholder="Duration"
                        components={customComponents}
                      />
                    </div>
                    <Link
                      to={"/products/" + selectedSubscriptionItem.product.slug}
                      className="price-value"
                    >
                      {selectedSubscriptionItem.product.currency +
                        formatPrice(selectedSubscriptionItem.selling_price)}
                    </Link>
                  </div>

                  <div className="qty-wrapper">
                    <p className="mb-0">
                      {" "}
                      Qty : {selectedSubscriptionItem.qty}
                    </p>
                    <p className="mb-0">
                      {" "}
                      SubTotal :{" "}
                      {selectedSubscriptionItem.product.currency +
                        formatPrice(
                          selectedSubscriptionItem.total_selling_price
                        )}
                    </p>
                  </div>
                </div>
                <div className="bttn-group">
                  <Link onClick={() => handleUpdateSubscription(selectedSubscriptionItem)} className="cutsom-bttn">
                    {" "}
                    Save & Update
                  </Link>
                  <Link
                    onClick={handleToggle}
                    className="cutsom-bttn cancelled-bttn"
                  >
                    {" "}
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default MySubscriptionComp;
